import CommonConstants from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import { Component, Vue } from 'vue-property-decorator'
import CAJG1090Service from './CAJG1090Service'
import CAJG1090ViewModel from './CAJG1090ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import '@/assets/css/colorbox.css'
import CommonUtil from '@/common/utils/CommonUtil'
import TransportService from '@/common/TransportService'
import { DigitalBookButton } from '@/common/utils/modules-util'
import { fixedContent, fixedContentNoLogin } from '@/assets/js/main.js'
import ColorBox from '@/assets/js/components/colorbox.js'
@Component({
  name: 'CAJG1090',
  components: {}
  })
export default class CAJG1090Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private cajg1090ViewModel: CAJG1090ViewModel = {
    marketInfoHtmlInfo: {
      content: ''
    },
    batchDispDiv: '',
    userInfor: null
  }

  private cajg1090Service: CAJG1090Service = new CAJG1090Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    fixedContentNoLogin()
    await this.init()
    this.$nextTick(() => {
      ColorBox()
      const digitalBookButton = new DigitalBookButton('.js-digital-book')
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const transportPromise = (async () => {
      // システムアクティビティログを実行する（トランスポート）
      const fullPath = this.$route.fullPath
      if (
        SessionStorageService.getItem(CommonConstants.USER_INFO) &&
        !CommonUtil.isWhiteUrl(fullPath)
      ) {
        return TransportService.callAPITransport(
          CommonConstants.URL_CAJG1090,
          null,
          null
        )
      }
      return null
    })
    const [caja1090ResponseModel] = await Promise.all([
      this.cajg1090Service.callAPICAJA1090(),
      transportPromise()
    ])
    if (CommonUtil.isNotEmpty(caja1090ResponseModel.marketInfoHtmlInfo)) {
      this.cajg1090ViewModel.marketInfoHtmlInfo.content =
        CommonUtil.replacePathCMS(
          caja1090ResponseModel.marketInfoHtmlInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1090ResponseModel.marketInfoHtmlInfo.path
        )
    } else {
      this.cajg1090ViewModel.marketInfoHtmlInfo = null
    }
    this.cajg1090ViewModel.batchDispDiv = caja1090ResponseModel.batchDispDiv

    if (caja1090ResponseModel.userInfor) {
      this.cajg1090ViewModel.userInfor = JSON.parse(
        SessionStorageService.getItem(CommonConstants.USER_INFO)
      )
    }
  }

  /**
   * 学習メニューボタン押下
   */
  private gotoCAJG1110() {
    this.$router.push({ name: 'cajg1110' })
  }

  /**
   * 学習メニュートップ（ログイン後）(CAJG1060 )画面に遷移する。
   */
  private gotoCAJG1060() {
    this.$router.push({ name: 'cajg1060' })
  }
}
